import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction } from '@ztechapps/common.contract'

@InputType()
export class PreviewSchoolByJoinCodeArgs extends ActionArgs {
  /** The school's `Company.code`, typed by the teacher before they see the confirmation. */
  @Field(() => String)
  joinCode: string
}

/**
 * Read-only preview for the mobile join screen — resolves the school name
 * for a typed join code so the app can name the school before the teacher confirms the
 * irreversible transfer. Returns the school name alone; no member counts, no balances, no ids
 * beyond what step 1 of the join screen needs (this query is otherwise a bare enumeration
 * surface over `Company.code`). An unknown code raises `SchoolJoinCodeInvalidException`
 * rather than returning null, mirroring `PreviewSchoolInvite`'s single-indistinguishable-failure
 * shape.
 */
export interface IPreviewSchoolByJoinCode extends IAction<string, PreviewSchoolByJoinCodeArgs> {}
